export const LandingViewTexts = {
    line1: 'Hello!',
    line2: 'I\'m Parth',
    line3: 'A Software Engineer.'
}
